export default "__VITE_ASSET__DpWWMZ57__"